import request from 'superagent'
import Config from '../config'

export default {
  getUser () {
    return request.get('/accounts/api/current?_productId=131').withCredentials()
  },
  getSolarUser () {
    return request.get(`${Config.YST_HOST}/user-profile/api/userGrades`)
      .query().withCredentials()
  },
  getUserInfo () {
    return request.get('/profile/api/user-info?_productId=131').withCredentials()
  },
  getUserEstimateInfo () {
    return request.get('/ape-estimate/api/estimates/setting?_productId=131').withCredentials()
  },
  getQuizzes () {
    return request.get('/ape-baggins/api/quizzes?_productId=131&phaseId=2').withCredentials()
  },
  getEstimate (userId, majorId, quizId) {
    return request.get(`/ape-estimate/api/users/${userId}/estimate?_productId=131&majorId=${majorId}&quizId=${quizId}`).withCredentials()
  },
  getEstimateStat (quizId, majorId) {
    return request.get(`/ape-estimate/api/estimate-stat?_productId=131&quizId=${quizId}&majorId=${majorId}`).withCredentials()
  },
  setUserInfo (quizId, majorId) {
    return request.put('/ape-estimate/api/estimates/setting?_productId=131').query({
      quizId: quizId,
      major: majorId
    }).withCredentials()
  }
}



// WEBPACK FOOTER //
// ./src/services/api.js